import React, { useState, useContext, useEffect } from "react";
import * as api from "../../../api/apiConnector.js";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import { useEditPanelContext } from "./edit_panel_context.js";
import UserContext from "../../../components/User_Context.js";

function DownloadHistory() {
  const { t } = useTranslation("labels");
  const { downloadHistory } = useEditPanelContext();

  // 1. State
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // 2. Calculations
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = downloadHistory.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(downloadHistory.length / itemsPerPage);
  const fillerRowCount = Math.max(0, itemsPerPage - currentItems.length);

 
  const getPagedNumbers = () => {
    let maxButtons = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxButtons / 2));
    let endPage = Math.min(totalPages, startPage + maxButtons - 1);

    // Adjust if we are at the end to ensure we still show 5 buttons if possible
    if (endPage - startPage + 1 < maxButtons) {
      startPage = Math.max(1, endPage - maxButtons + 1);
    }

    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="container-fluid mx-auto py-0 h-80 d-flex flex-column pt-4 overflow-hidden ">
      <div className="flex-grow-1 shadow"   style={{
              borderRadius: "12px",
          
            }}>
        {downloadHistory.length > 0 ? (
          <div
            className="w-80 border overflow-hidden"
            // We use inline styles here to FORCE the rounded corners, ignoring Bootstrap version issues
            style={{
              borderRadius: "12px",
              borderColor: "#dee2e6",
              borderStyle: "solid",
              borderWidth: "1px",
            }}
          >
            <table className="table table-striped table-hover mb-0">
              <thead className="bg-white">
                <tr>
                  <th scope="col" className="py-3 ps-4">
                    {t("username", { ns: "labels" })}
                  </th>
                  <th scope="col" className="py-3">
                    {t("userEmail", { ns: "labels" })}
                  </th>
                  <th scope="col" className="py-3">
                    {t("date", { ns: "labels" })}
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map((download) => (
                  <tr key={download.id}>
                    <td className="ps-4">{download.user.name}</td>
                    <td>{download.user.email}</td>
                    <td>{new Date(download.action_date).toLocaleString()}</td>
                  </tr>
                ))}
                {Array.from({ length: fillerRowCount }).map((_, idx) => (
                  <tr key={`filler-${idx}`}>
                    <td className="ps-4">&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div
            className="w-80   border overflow-hidden "
          
            style={{
              borderRadius: "12px",
              borderColor: "#dee2e6",
              borderStyle: "solid",
              borderWidth: "1px",
            }}
          >
            <table className="table table-striped table-hover mb-0 ">
              <thead className="bg-white">
                <tr>
                  <th scope="col" className="py-3 ps-4">
                    Username
                  </th>
                  <th scope="col" className="py-3">
                    User Email
                  </th>
                  <th scope="col" className="py-3">
                    Date
                  </th>
                </tr>
              </thead>
              <tbody>
                {Array.from({ length: itemsPerPage }).map((_, idx) => (
                  <tr key={`empty-${idx}`}>
                    {idx === 4 ? (
                      <td colSpan={3} className="ps-4 text-muted text-center">
                        No download history
                      </td>
                    ) : (
                      <>
                        <td >&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
            
          </div>
          
        )}
      </div>
      {/* IF NO DOWNLOAD HISTORY, extra padding for shadow*/}
      {totalPages <= 1 && (
        <div className="h-100">
          <div className="h-100">
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          </div>
        </div>
      )}
      {/* PAGINATION CONTROLS */}
      {totalPages > 1 && (
        <nav aria-label="Table pagination " className=" mt-5 ">
          <ul className="pagination justify-content-center">
            {/* First Page Button (Optional but recommended for long lists) */}
            {currentPage > 4 && (
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(1)}
                >
                  &laquo;&laquo;
                </button>
              </li>
            )}

            {/* Previous Button */}
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link"
                onClick={() => handlePageChange(currentPage - 1)}
              >
                &laquo;
              </button>
            </li>

            {/* DYNAMIC PAGE NUMBERS */}
            {getPagedNumbers().map((page) => (
              <li
                key={page}
                className={`page-item ${currentPage === page ? "active" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(page)}
                >
                  {page}
                </button>
              </li>
            ))}

            {/* Next Button */}
            <li
              className={`page-item ${
                currentPage === totalPages ? "disabled" : ""
              }`}
            >
              <button
                className="page-link"
                onClick={() => handlePageChange(currentPage + 1)}
              >
                &raquo;
              </button>
            </li>

            {/* Last Page Button */}
            <li
              className={`page-item ${
                currentPage === totalPages ? "disabled" : ""
              }`}
            >
              <button
                className="page-link"
                onClick={() => handlePageChange(totalPages)}
              >
                &raquo;&raquo;
              </button>
            </li>
          </ul>
        </nav>
      )}
    </div>
  );
}
export default DownloadHistory;
